import React from 'react';
import { 
  BrainCircuit, 
  Calendar, 
  TrendingUp, 
  BarChart3, 
  Target, 
  Users,
  ArrowRight
} from 'lucide-react';
import { Link } from 'react-router-dom';

const features = [
  {
    icon: BrainCircuit,
    title: 'IA Avançada',
    description: 'Algoritmos inteligentes que analisam tendências e geram ideias personalizadas para o seu conteúdo.'
  },
  {
    icon: Calendar,
    title: 'Planejamento Estratégico',
    description: 'Calendário de conteúdo otimizado com base nos melhores horários para seu público.'
  },
  {
    icon: TrendingUp,
    title: 'Análise de Tendências',
    description: 'Identificação em tempo real de tópicos em alta no seu nicho.'
  },
  {
    icon: BarChart3,
    title: 'Métricas Detalhadas',
    description: 'Acompanhe o desempenho do seu conteúdo com análises profundas.'
  },
  {
    icon: Target,
    title: 'Segmentação Precisa',
    description: 'Alcance o público certo com recomendações baseadas em dados.'
  },
  {
    icon: Users,
    title: 'Engajamento Otimizado',
    description: 'Aumente suas interações com estratégias testadas e aprovadas.'
  }
];

export default function Features() {
  return (
    <section className="relative py-24 bg-primary-600">
      <div className="container relative mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Recursos Poderosos para seu Crescimento
          </h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Ferramentas avançadas que transformam sua estratégia de conteúdo e impulsionam seus resultados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="p-8 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/15 transition-all"
              >
                <div className="w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center mb-6">
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-white/80 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-20 text-center">
          <Link
            to="/cadastro"
            className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-primary-600 bg-white rounded-full hover:bg-primary-50 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            Comece Agora
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}